
import Button from '../../../components/base/Button';

export default function ServicesSection() {
  const services = [
    {
      icon: 'ri-computer-line',
      title: 'Managed IT Services',
      description: 'Complete IT infrastructure management, monitoring, and maintenance to keep your systems running smoothly 24/7.',
      features: ['Proactive monitoring', 'Regular maintenance', 'Performance optimization', 'Issue resolution']
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Cybersecurity Solutions',
      description: 'Comprehensive security measures to protect your sensitive donor data and organizational information.',
      features: ['Threat detection', 'Data encryption', 'Security audits', 'Compliance support']
    },
    {
      icon: 'ri-cloud-line',
      title: 'Cloud Migration & Management',
      description: 'Seamless transition to cloud platforms with ongoing management and optimization for cost efficiency.',
      features: ['Cloud strategy', 'Data migration', 'Cost optimization', 'Backup solutions']
    },
    {
      icon: 'ri-microsoft-fill',
      title: 'Microsoft 365 Implementation',
      description: 'Complete setup and optimization of Microsoft 365 for nonprofits with discounted licensing.',
      features: ['Setup & configuration', 'Microsoft Entra Connect', 'User training', 'Security setup', 'Ongoing support']
    },
    {
      icon: 'ri-google-line',
      title: 'Google Workspace Implementation',
      description: 'Complete setup and optimization of Google Workspace for nonprofits with discounted licensing and training.',
      features: ['Setup & configuration', 'User training', 'Security setup', 'Ongoing support']
    },
    {
      icon: 'ri-database-line',
      title: 'Data Backup & Recovery',
      description: 'Reliable backup solutions and disaster recovery planning to protect your critical organizational data.',
      features: ['Automated backups', 'Disaster recovery', 'Data restoration', 'Business continuity']
    }
  ];

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="services" className="py-12 sm:py-16 lg:py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-gray-900 mb-4">
            Comprehensive IT Services for Virginia Nonprofits
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            We understand the unique challenges nonprofits face. Our tailored tekFLOW IT solutions help you maximize 
            your impact while minimizing technology costs and complexity.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {services.map((service, index) => (
            <div key={index} className="bg-white rounded-xl shadow-lg p-6 sm:p-8 hover:shadow-xl transition-shadow duration-300">
              <div className="w-12 h-12 sm:w-16 sm:h-16 bg-blue-100 rounded-lg flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${service.icon} text-xl sm:text-2xl text-blue-600`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">{service.title}</h3>
              <p className="text-sm sm:text-base text-gray-600 mb-4 sm:mb-6">{service.description}</p>
              <ul className="space-y-2">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex} className="flex items-center text-sm text-gray-700">
                    <i className="ri-check-line text-teal-600 mr-2 flex-shrink-0"></i>
                    {feature}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center">
          <Button 
            size="lg"
            onClick={() => scrollToSection('consultation')}
            className="w-full sm:w-auto"
          >
            <i className="ri-phone-line mr-2"></i>
            Discuss Your IT Needs
          </Button>
        </div>
      </div>
    </section>
  );
}
